import get from 'lodash/get';
import config from '../../common/config';
import openPopoutPlayerWindow from './utils/openPopoutPlayerWindow';
import { POPUP_PLAYER_READY, UPDATE_POPUP_PLAYER } from './constants/message';

const { insecureEmbedOrigin } = config;

const dimensions = {
  width: 640,
  height: 100,
};

export default class PopoutPlayerWindow {
  constructor() {
    this.popoutWindow = null;
    this.guideId = null;
    this.isPremium = null;
    this.handlePopoutPremiumStatusEvent =
      this.handlePopoutPremiumStatusEvent.bind(this);
  }

  get isWindowOpen() {
    return !!(this.popoutWindow && !this.popoutWindow.closed);
  }

  get embedUrl() {
    return `${insecureEmbedOrigin}/embed/player/${this.guideId}?partnerId=${this.partnerId}&isPopout=true`;
  }

  handlePopoutPremiumStatusEvent(event) {
    const { data, origin } = event;
    const type = get(data, 'type');
    const isValidMessage =
      type === POPUP_PLAYER_READY && origin === insecureEmbedOrigin;

    if (isValidMessage) {
      this.send(this.guideId, this.isPremium);
    }
  }

  open(guideId, isPremium, partnerId) {
    this.guideId = guideId;
    this.isPremium = isPremium;
    this.partnerId = partnerId;
    // this is used as a way to communicate the premium status once the popout window loads
    window.addEventListener('message', this.handlePopoutPremiumStatusEvent);

    this.popoutWindow = openPopoutPlayerWindow(
      this.embedUrl,
      dimensions.width,
      dimensions.height,
    );
  }

  send(guideId, isPremium) {
    this.popoutWindow.focus();

    if (guideId !== this.guideId) {
      this.guideId = guideId;
      this.popoutWindow.location.replace(this.embedUrl);
      return;
    }

    this.popoutWindow.postMessage(
      { type: UPDATE_POPUP_PLAYER, isPremium },
      insecureEmbedOrigin,
    );
  }

  close() {
    window.removeEventListener('message', this.handlePopoutPremiumStatusEvent);
    this.popoutWindow.close();
  }
}
